// components/ColorPickerButton.jsx
import React, { useState, useEffect } from 'react';
import { HexColorPicker } from 'react-colorful';

const NoColorButton = () => (
  <div className="w-6 h-6 border border-gray-600 hover:border-white relative">
    <svg viewBox="0 0 24 24" className="w-full h-full">
      <rect width="24" height="24" fill="transparent"/>
      <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="2"/>
    </svg>
  </div>
);


const ColorPickerButton = ({ colorOptions, handleChange, property, displayName, currentColor, position='top' }) => {
  const [activeColorPicker, setActiveColorPicker] = useState(null);
  const [tempColor, setTempColor] = useState(currentColor);

  useEffect(() => {
    setTempColor(currentColor)
  }, [currentColor])

  const submitColor = () => {
    handleChange(property, tempColor);
  };

  const displayColor = currentColor === null ? 'transparent' : currentColor;

  return (
    <div className="relative flex items-center justify-between">
      {displayName && (
        <span className="w-32 text-[0.8em] font-medium">{displayName}</span>
      )}
      <button
        onClick={() => setActiveColorPicker(activeColorPicker === property ? null : property)}
        className="flex items-center space-x-2 px-2 py-1 bg-gray-700 rounded hover:bg-gray-600"
      >
        <div className="w-4 h-4 rounded border border-gray-400 relative">
          {currentColor === null ? (
            <svg viewBox="0 0 16 16" className="w-full h-full">
              <rect width="16" height="16" fill="transparent"/>
              <line x1="2" y1="2" x2="14" y2="14" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
          ) : (
            <div className="w-full h-full" style={{ backgroundColor: displayColor }} />
          )}
        </div>
        <span className="text-[0.8em] w-16 font-mono">
          {currentColor === null ? 'None' : (currentColor || 'Select')}
        </span>
      </button>
      
      {activeColorPicker === property && (
        <div className={`absolute ${position === 'top' ? 'bottom-full' : 'top-full'} mb-2 right-0 z-10 border border-gray-700 bg-gray-900 p-3 rounded-lg shadow-xl`}>
          <div className="bg-gray-900 p-2 rounded-lg shadow-xl w-48">
            <div className="flex flex-wrap justify-between gap-1 mb-2">
              {colorOptions.map((color) => (
                <button
                  key={color}
                  className={`w-6 h-6 border border-gray-600 hover:border-white ${displayName ?? 'rounded'}`}
                  style={{ backgroundColor: color }}
                  onClick={() => {
                    handleChange(property, color);
                    setActiveColorPicker(null);
                  }}
                />
              ))}
              <button
                className="w-6 h-6 border border-gray-600 hover:border-white"
                onClick={() => {
                  handleChange(property, null);
                  setActiveColorPicker(null);
                }}
              >
                <NoColorButton />
              </button>
            </div>
            <div className="mb-2">
              <HexColorPicker
                color={currentColor || '#000000'}
                onChange={(color) => handleChange(property, color)}
                style={{ width: '100%', height: '100px' }}
              />
            </div>
            <input
              type="text"
              value={tempColor || ''}
              onChange={(e) => setTempColor(e.target.value)}
              onBlur={submitColor}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  submitColor();
                }
              }}
              className="px-2 py-1 text-sm bg-gray-700 rounded border border-gray-600 font-mono focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPickerButton;





// import React, { useState, useEffect } from 'react';
// import { HexColorPicker } from 'react-colorful';


// // Color picker with popup positioning
//   const ColorPickerButton = ({ colorOptions, handleChange, property, displayName, currentColor, position='top' }) => {
//     const [activeColorPicker, setActiveColorPicker] = useState(null);
//     const [tempColor, setTempColor] = useState(currentColor);
//     // const isCustomColor = !colorOptions.includes(currentColor);

//     useEffect(() => {
//       setTempColor(currentColor)
//     }, [currentColor])

//     const submitColor = () => {
//       handleChange(property, tempColor);
//     };

//     return (
//       <div className="relative flex items-center justify-between">
//         {displayName &&
//             <span className="w-32 text-sm font-medium">{displayName}</span>
//         }
//         <button
//           onClick={() => setActiveColorPicker(activeColorPicker === property ? null : property)}
//           className="text-sm flex items-center space-x-2 px-2 py-1 bg-gray-700 rounded hover:bg-gray-600"
//         >
//           <div
//             className="w-4 h-4 rounded border border-gray-400"
//             style={{ backgroundColor: currentColor }}
//           />
//           <span className="w-16 text-sm font-mono">{currentColor || 'Select'}</span>
//         </button>
        
//         {activeColorPicker === property && (
//           // <div className="absolute left-0 top-8 z-10">
//           <div className={`absolute ${position === 'top' ? 'bottom-full' : 'top-full'} mb-2 right-0 z-10 border border-gray-700 bg-gray-900 p-3 rounded-lg shadow-xl`}>
//             <div className="bg-gray-900 p-2 rounded-lg shadow-xl w-48">
//               {/* <div className="grid grid-cols-4 gap-1 mb-2"> */}
//               <div className="flex flex-wrap justify-between gap-1 mb-2">
//                 {colorOptions.map((color) => (
//                   <button
//                     key={color}
//                     className={`w-6 h-6 border border-gray-600 hover:border-white ${displayName ?? 'rounded'}`}
//                     style={{ backgroundColor: color }}
//                     onClick={() => {
//                       handleChange(property, color);
//                       setActiveColorPicker(null);
//                     }}
//                   />
//                 ))}
//               </div>
//               <div className="mb-2">
//                 <HexColorPicker
//                   color={currentColor}
//                   onChange={(color) => handleChange(property, color)}
//                   style={{ width: '100%', height: '100px' }}
//                 />
//               </div>
//               <input
//                 type="text"
//                 value={tempColor || ''}
//                 onChange={(e) => setTempColor(e.target.value)}
//                 onBlur={submitColor}
//                 onKeyDown={(e) => {
//                   if (e.key === 'Enter') {
//                     submitColor();
//                   }
//                 }}
//                 className="px-2 py-1 text-sm bg-gray-700 rounded border border-gray-600 font-mono focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   export default ColorPickerButton;